import { memo } from 'react';

import { MessageSquareIcon } from '@air/design-icons';

/**
 * Menu rows pass `className="size-4"`, which cannot size an ADS icon (it emits its own size class
 * and defaults to 20px). Pin `sm` here so Prompt matches neighboring next-icons at 16px.
 */
export const PromptInCanvasIcon = memo(() => <MessageSquareIcon size="sm" />);

PromptInCanvasIcon.displayName = 'PromptInCanvasIcon';
